import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLanguage } from "context/languageContext";
import { getPlaceStyles } from "services/homePage.services";
import { useNavigate } from "react-router-dom";
import styles from "./styles.module.scss";

const OfficeStylesSection = () => {
  const [t] = useTranslation("global");
  const { language } = useLanguage();
  const [placeStyles, setPlaceStyles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const fetchStyles = async () => {
    setError(null);
    setLoading(true);
    try {
      const styles = await getPlaceStyles(language);
      setPlaceStyles(styles);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchStyles();
  }, [language]);

  const handleStyleClick = (styleId) => {
    navigate(`/search?style=${styleId}`);
  };

  const getBackgroundStyle = (imageUrl) => ({
    backgroundImage: `url(${imageUrl || "fallback-image-url.jpg"})`,
  });

  if (loading) return <div className={styles.loading}></div>;
  if (error) return <div className={styles.error}>{error}</div>;

  return (
    <section className={`${styles.officeStyles} pageContainer`}>
<div className={styles.rectangle}><h2 className={styles.heading} dangerouslySetInnerHTML={{__html:t("home.stylesMainHeading")}}/></div>
      <div className={`${styles.gridLayout} mediumContainer`}>
        {/* Row 1: Text box (1/3) + Style box (2/3) */}
        <div className={styles.row}>
          <div 
            className={`${styles.item} ${styles.textBox}`}
            onClick={() => handleStyleClick(placeStyles[0]?.id)}
          >
            <div className={styles.textContent}>
              <p className={styles.textContentHeading} dangerouslySetInnerHTML={{__html:t("home.stylesHeading")}}/>
              <p>{t("home.stylesText")}</p>
            </div>
          </div>
          <div 
            className={`${styles.item} ${styles.largeBox}`}
            style={getBackgroundStyle(placeStyles[0]?.image_url)}
            onClick={() => handleStyleClick(placeStyles[0]?.id)}
          >
            <button className={styles.btn}>
              {placeStyles[0]?.name || ""}
            </button>
          </div>
        </div>

        {/* Row 2: 3 equal boxes */}
        <div className={styles.row}>
          {[1, 2, 3].map((index) => (
            <div
              key={index}
              className={`${styles.item} ${styles.mediumBox}`}
              style={getBackgroundStyle(placeStyles[index]?.image_url)}
              onClick={() => handleStyleClick(placeStyles[index]?.id)}
            >
              <button className={styles.btn}>
                {placeStyles[index]?.name || ""}
              </button>
            </div>
          ))}
        </div>

        {/* Row 3: 2 equal boxes */}
        <div className={styles.row}>
          {[4, 5].map((index) => (
            <div
              key={index}
              className={`${styles.item} ${styles.largeBox}`}
              style={getBackgroundStyle(placeStyles[index]?.image_url)}
              onClick={() => handleStyleClick(placeStyles[index]?.id)}
            >
              <button className={styles.btn}>
                {placeStyles[index]?.name || ""}
              </button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default OfficeStylesSection;